// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"c61ceb97","404":"d2bb54a5","787":"7c5c4490","842":"cb395cd1","856":"8b7ab9aa"}[chunkId] + ".chunk.js";
};